import { Storage } from "aws-amplify";

/**
 * Generates a unique file name using the current timestamp (Date.now())
 * Upload the file to the user’s folder in S3 using the Storage.vault.put() object.
 * returns stored object key
 */
export async function s3Upload(file) {
  //TODO: add a hash of the userid on the end/
  const filename = `${Date.now()}-${file.name}`;

  const stored = await Storage.vault.put(filename, file, {
    contentType: file.type
  });

  return stored.key;
}



// WEBPACK FOOTER //
// ./src/libs/awsLib.js